
import { granjaApi } from "../../api";
import { useFacturasStore } from "../../store";

import Swal from "sweetalert2";




export const startFacturaXID = async(id) => {
    try {
        if( id === 'new') return null;
        const { data } = await granjaApi.get(`/factura/xid/${id}`);
        return data.data;
    } catch (error) {
        console.log(error)
        Swal.fire('Error', error.response.data.msg, 'error');
    }
}





export const startListadoFacturas = async({ page=0, termino='' }) => {
    try {
        const params = new URLSearchParams();
        params.append('page',  page.toString());
        params.append('termino',  termino);

        const { data } = await granjaApi.get('/factura/todos', { params });
        useFacturasStore.setState({ totalFacturas: data.total });
        return data.data;
    } catch (error) {
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        throw new Error(errores);
    }
}



export const startSavingFacturas = async(factura) => {
    try {
        await granjaApi.post('/factura/new', factura);
        Swal.fire('Exitoso', 'Factura Creada', 'success');
        return true;
    } catch (error) {
        const msg = error?.response?.data?.errors?.[0]?.msg || error?.response?.data?.msg || 'Ocurrió un error inesperado';
        Swal.fire('Error', msg, 'error');
        return false;
    }
} 




export const startAgregarFacturaABodega = async(id) => {
    try {
        const { data } = await granjaApi.get(`/factura/ingreso/${id}`);
        Swal.fire('Exitoso', data.msg, 'success');
        return true;
    } catch (error) {
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        Swal.fire('Ya fue ingresada', errores, 'info');
        return false;
    }
}
